// Configuration for EventPopupManager component
export const createEventPopupManagerConfig = ({
    // Main event popup state
    isOpen,
    setOpen,
    isEdit,
    anchor,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    popupEventTime,
    popupEventCreated,
    popupEventEdited,
    selectedColor,
    isBusy,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    saveEvent,
    onClose,
    onDelete,
    onEventBusyChange,
    onHandleEventXChange,
    onHandleEventInvoicedChange,
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    headerText,
    popupButtons,
    responsivePopup,
    
    // References
    startRef,
    endRef,
    
    // Hover popup state
    isHoverOpen,
    isHoverDayOpen,
    
    // Holiday popup state
    holidayAnchor,
    holidayName,
    
    // Event handlers for hover/holiday
    onMouseEnter,
    onMouseLeave,
    onHolidayMouseEnter,
    onHolidayMouseLeave,
    
    // Resources and utilities
    resources,
    flattenArr,
    getDateFromTimestamp,
    eventContent
}) => ({
    // Main event popup
    isOpen,
    setOpen,
    isEdit,
    saveEvent,
    onClose,
    headerText,
    anchor,
    onDelete,
    onEventBusyChange,
    onHandleEventXChange,
    onHandleEventInvoicedChange,
    popupEventTitle,
    titleChange,
    popupEventDescription,
    descriptionChange,
    selectedColor,
    isBusy,
    isX,
    isEditable,
    popupEventAllDay,
    allDayChange,
    popupEventDate,
    changeStartDate,
    changeEndDate,
    startRef,
    endRef,
    isChecked,
    handleResourceCheckInEvent,
    popupButtons,
    responsivePopup,
    changeColor,
    
    // Hover popup
    isHoverOpen,
    popupEventTime,
    popupEventCreated,
    popupEventEdited,
    eventContent,
    onMouseEnter,
    onMouseLeave,
    
    // Holiday popup
    isHoverDayOpen,
    holidayAnchor,
    holidayName,
    onHolidayMouseEnter,
    onHolidayMouseLeave,
    
    // Resources and utilities
    resources,
    flattenArr,
    getDateFromTimestamp
});
